import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Avatar from "@mui/material/Avatar";
import globals from "../../globals";
import Link from "@mui/material/Link";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { styled } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from '@mui/icons-material/Info';
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import { formatEur, formatLevaTooltip } from "../../utils";


const CartButton = styled(Button)(() => ({
  color: globals.colors.backgroundColor,
  backgroundColor: globals.colors.lightRed,
  // borderColor: globals.colors.lightRed,
  // border: `1px solid ${globals.colors.darkBlue}`,
  borderRadius: 3,
  '&:hover': {
    backgroundColor: globals.colors.darkRed,
    color: globals.colors.backgroundColor,
  },
}));

export default function CardDesign({ id, name, image, author, pic, price, duration, url, capacity, enrolled_students_count }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = () => {
    addToCart({ id: id, name: name, price: price, instructor_name: author, price: price, title: name, duration: duration });
    navigate(`/choose/${id}`);
  }

  return (
    <Card sx={{ width: 350, height: 390, borderRadius: 3 }}>
      <Link href={`/course/${id}`}>
        <CardMedia
          sx={{ height: 140 }}
          image={image}
          title="course title"
        />
      </Link>
      <Grid item>
        <CardContent sx={{ justifyContent: 'center', maxHeight: 300 }}>
          <Typography gutterBottom variant="h7" component="div" sx={{ textAlign: 'center', fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 18 }}>
            <Link href={`/course/${id}`} sx={{
              textDecoration: 'none', "&:hover": {
                color: globals.colors.lightBlue,
              }
            }} underline='none' color={'inherit'}>
              {(name.length <= 32) ? name : name.slice(0, 29).concat('...')}
            </Link>
          </Typography>
          <Grid container justifyContent={'space-evenly'} sx={{ mt: 3 }}>
            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
              <Avatar sx={{ alignSelf: 'center', width: 56, height: 56 }} src={pic} />
            </Grid>
            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
              <Typography sx={{ alignSelf: 'center' }} variant="body1">{author}</Typography>
            </Grid>
          </Grid>
          <Divider orientation="horizontal" sx={{ mt: 1 }} />
          <Grid container sx={{ mt: 2 }} justifyContent={'space-around'}>
            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
              <Typography sx={{ ml: 1 }}><AccessTimeIcon style={{ color: globals.colors.textColor }} sx={{ mr: 1, mb: -1 }} />{duration} мин.</Typography>
            </Grid>
            <Grid item display="flex" justifyContent="center" alignItems="center" size="grow" justifySelf={'auto'}>
              <Typography>{formatEur(price)}

                <Tooltip title={formatLevaTooltip(price)}>
                  <InfoIcon fontSize="small" sx={{ color: globals.colors.darkBlue }} />
                </Tooltip>
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ mt: 2 }} justifyContent={'center'}>
            <CartButton disabled={(enrolled_students_count >= capacity) ? enrolled_students_count : false} size="medium" onClick={handleAddToCart}><AddShoppingCartIcon style={{ color: globals.colors.textColor }} />{enrolled_students_count >= capacity ? 'Курсът е запълнен' : 'Добавяне в количка'}</CartButton>
          </Grid>
        </CardContent>
      </Grid>
    </Card>
  );
}